import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PowerOff } from 'lucide-react';
import { AccountModules, useAccountModules } from '../services/accountModulesService';

// Mostra a tela só se o módulo estiver ligado; senão explica onde ligar.
export default function ModuleGate({ module, name, children }: { module: keyof AccountModules; name: string; children: React.ReactNode }) {
  const { t } = useTranslation();
  const mods = useAccountModules();
  if (!mods) return null;
  if (mods[module]) return <>{children}</>;
  return (
    <div className="mx-auto mt-16 max-w-md rounded-2xl border border-gray-200 bg-white p-8 text-center dark:border-gray-700 dark:bg-gray-800">
      <PowerOff className="mx-auto h-10 w-10 text-gray-400" />
      <h2 className="mt-3 text-lg font-semibold text-gray-900 dark:text-white">
        {t('modules.disabledTitle', '{{name}} está desligado', { name })}
      </h2>
      <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{t('modules.disabledText', 'Você pode ligar este módulo quando quiser.')}</p>
      <Link to="/settings/modules" className="mt-5 inline-block rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700">
        {t('modules.goToSettings', 'Ir para Configurações → Módulos')}
      </Link>
    </div>
  );
}
